// extracted by mini-css-extract-plugin
export default {"wrapper":"Cards_wrapper__Zm5mW","list":"Cards_list__4v1k+","list__item":"Cards_list__item__Ce2It"};